import APIv4GetProductByIdResponseAdapter from './APIv4GetProductByIdResponseAdapter';
const APIv4GetProductBySkuResponseAdapter = {
  getProductInfo: item => {
    const {
      price_info,
      stock
    } = item;
    return {
      categories: item.categories,
      country: item.country,
      descriptions: APIv4GetProductByIdResponseAdapter.mapDescriptions(item.descriptions),
      hiddenPrice: item.price_hide,
      id: item.productID,
      sku: item.meta_refid_linked,
      imageUrl: item.image,
      price: {
        country: price_info.country,
        currency: price_info.currency,
        currencies: Object.keys(price_info.currencies).map(k => ({
          currency: k,
          prices: price_info.currencies[k].prices.map(p => ({
            volume: p.volume,
            volumePrice: p.volume_price,
            recommendedPrice: p.recommended_price,
            unitCost: p.unit_cost,
            licence: p.licence,
            price: p.price,
            oldPrice: p.crossed_price ?? 0
          }))
        })),
        includesTaxes: price_info.tax_included,
        prices: price_info.prices,
        taxType: price_info.tax_type
      },
      gallery: APIv4GetProductByIdResponseAdapter.mapGallery(item),
      state: item.state,
      stock: {
        lowStockAlert: parseInt(stock.low_stock_alert),
        policy: stock.policy,
        stock: parseInt(stock.stock)
      },
      type: item.type,
      custom_fields: item.custom_fields,
      specificV4: item.specific
    };
  },
  toProduct: response => {
    const {
      response_data
    } = response;
    return APIv4GetProductBySkuResponseAdapter.getProductInfo(response_data);
  }
};
export default APIv4GetProductBySkuResponseAdapter;
